import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareService } from '../share.service';

@Component({
  selector: 'app-share-model',
  templateUrl: './share-model.component.html',
  styleUrls: ['./share-model.component.css']
})
export class ShareModelComponent {
  @Input() referralLink: string = '';

  constructor(
    public dialogRef: MatDialogRef<ShareModelComponent>,
    private shareService: ShareService,
    @Inject(MAT_DIALOG_DATA) public data: { referralLink: string }
  ) {
    this.referralLink = data.referralLink;
  }

  close(): void {
    this.dialogRef.close();
  }

  copyLink(): void {
    this.shareService.copyToClipboard(this.referralLink);
  }

  async share(): Promise<void> {
    await this.shareService.shareLink(this.referralLink);
  }
}
